import { Component, OnInit, signal } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DateFilter, Month, Year } from 'src/app/interfaces';
import moment from 'moment';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatLabel, MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker,
} from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-export-deleted-rides',
  templateUrl: './export-deleted-rides.component.html',
  styleUrls: ['./export-deleted-rides.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatLabel,
    MatRadioGroup,
    MatRadioButton,
    MatFormField,
    MatSelect,
    MatOption,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class ExportDeletedRidesComponent implements OnInit {
  years = signal<Year[]>([]);
  months = signal<Month[]>([
    { value: 0, viewValue: 'Januari' },
    { value: 1, viewValue: 'Februari' },
    { value: 2, viewValue: 'Maart' },
    { value: 3, viewValue: 'April' },
    { value: 4, viewValue: 'Mei' },
    { value: 5, viewValue: 'Juni' },
    { value: 6, viewValue: 'Juli' },
    { value: 7, viewValue: 'Augustus' },
    { value: 8, viewValue: 'September' },
    { value: 9, viewValue: 'Oktober' },
    { value: 10, viewValue: 'November' },
    { value: 11, viewValue: 'December' },
  ]);
  dateFilter = signal<DateFilter[]>([
    { value: 'year', viewValue: 'Jaar' },
    { value: 'month', viewValue: 'Maand' },
    { value: 'week', viewValue: 'Week' },
    { value: 'day', viewValue: 'Dag' },
  ]);
  exportForm: UntypedFormGroup = this.fb.group({
    selectedFilter: ['year'],
    year: [moment().year(), Validators.required],
    month: [moment().month(), Validators.required],
    week: [moment().week(), Validators.required],
    day: [moment().toDate(), Validators.required],
  });

  weeks = signal<number[]>([]);
  days = signal<number[]>([]);
  constructor(
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<ExportDeletedRidesComponent>,
    private snackbar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth();
    const currentWeek = parseInt(moment(date).format('W'));
    const yearsArray: Year[] = [];
    let yearInStep = currentYear;
    for (let step = 0; step < 10; step++) {
      yearsArray.push({ value: yearInStep, viewValue: yearInStep.toString() });
      yearInStep = yearInStep - 1;
    }
    this.years.set(yearsArray);
    this.years().forEach((year) => {
      if (year.value === currentYear) {
        this.exportForm.value.year = year.value;
      }
    });
    this.months().forEach((month) => {
      if (month.value === currentMonth) {
        this.exportForm.value.month = month.value;
      }
    });
    const weeksArray: number[] = [];
    for (let step = 1; step < 54; step++) {
      weeksArray.push(step);
      if (step === currentWeek) {
        this.exportForm.value.week = step;
      }
    }
    this.weeks.set(weeksArray);
    const daysArray: number[] = [];
    for (let step = 1; step < 8; step++) {
      daysArray.push(step);
    }
    this.days.set(daysArray);
  }

  periodChange() {
    switch (this.exportForm.value.selectedFilter) {
      case 'year':
        this.exportForm.controls.year.enable();
        this.exportForm.controls.month.disable();
        this.exportForm.controls.day.disable();
        break;
      case 'month':
        this.exportForm.controls.year.enable();
        this.exportForm.controls.month.enable();
        this.exportForm.controls.day.disable();
        break;
      case 'week':
        this.exportForm.controls.year.enable();
        this.exportForm.controls.week.enable();
        this.exportForm.controls.day.disable();
        break;
      case 'day':
        this.exportForm.controls.year.disable();
        this.exportForm.controls.week.disable();
        this.exportForm.controls.day.enable();
        break;
    }
  }

  close() {
    const exportForm = this.exportForm.value;
    if (!exportForm.selectedFilter) {
      return this.snackbar.open('Selecteer een filter om verder te gaan.', 'X', {
        duration: 5000,
      });
    }
    let valueToExport = {};
    valueToExport['type'] = exportForm.selectedFilter;
    switch (exportForm.selectedFilter) {
      case 'day':
        valueToExport['day'] = exportForm.day.getDate();
        valueToExport['month'] = exportForm.day.getMonth();
        valueToExport['year'] = exportForm.day.getFullYear();
        break;
      case 'week':
        valueToExport['week'] = `${exportForm.year}-${exportForm.week}`;
        break;
      case 'month':
        valueToExport['month'] = exportForm.month;
        valueToExport['year'] = exportForm.year;
        break;
      case 'year':
        valueToExport['year'] = exportForm.year;
        break;
    }
    if (!valueToExport) {
      return this.snackbar.open('Vul een waarde in om verder te gaan.', 'X', {
        duration: 5000,
      });
    }
    this.dialogRef.close(valueToExport);
  }
}
